
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { CardAttributeModel } from '@pazion/pazion-catalog/src/models/member_card.model';
import CardDetailsFileUploader from "../atoms/CardDetailsFileUploader.vue";

@Component({
  components: {
    CardDetailsFileUploader
  }
})
export default class CardAttributesDynamicValueEditor extends Vue {

  @Prop() dynamicItem!: { key: string, value: CardAttributeModel };
  @Prop() itemIndex!: number;
  @Prop({ default: null }) field!: CardAttributeModel;
  @Prop({ default: false }) loadAttr!: boolean;

  public currentItem: { key: string, value: CardAttributeModel } | null = null;
  public fillOptions = [];

  setItemValue(value: string, noBuble?: boolean) {
    this.fillOptions[this.itemIndex].value = value;
    !noBuble &&
      this.updateBubleValue();
  }
  
  updateBubleValue() {
    this.$emit('onItemChange', this.fillOptions);
  }

  getPreviousOptionsValue() {
    this.currentItem = { ...this.dynamicItem };
    const parsedOpt = JSON.parse(this.field.fieldOptions);

      const prevParsed = JSON.parse(this.field.value);
      // NOTE: Find previous values for options
      const previousValue = parsedOpt.map(opt => {
        let prevVal
        prevParsed && Array.isArray(prevParsed) && prevParsed.length > 0 &&
        (prevVal = prevParsed.find(pv => pv.key === opt));
        const fillPrevValue = prevVal && prevVal.hasOwnProperty('value') ? prevVal.value : null;
        return {
          key: opt,
          value: fillPrevValue
        }
      })
    //NOTE: Set current item value
    this.currentItem = previousValue.find(pv => pv.key === this.currentItem.key);
    //NOTE: Set filed options
    this.fillOptions = previousValue; 
  }

  mounted() {
    this.getPreviousOptionsValue();
  }

}//
